export const AreaLineAnnotation = {
  padding: [35, 50],
  annotations: [
    {
      type: "text",
      position: ["min", "median"],
      content: "",
      offsetY: -4,
      style: {
        textBaseline: "bottom",
      },
    },
    {
      type: "line",
      start: ["min", "median"],
      end: ["max", "median"],
      style: {
        stroke: "red",
        lineDash: [2, 2],
      },
    },
  ],
};
export const lineMullitpleAnimation = {
  padding: [35, 50],
  yAxis: {
    label: {
      formatter: (v) => `${(v / 10e8).toFixed(1)} B`,
    },
  },
  legend: {
    position: "top",
  },
  smooth: true,
  // @TODO 后续会换一种动画方式
  animation: {
    appear: {
      animation: "path-in",
      duration: 5000,
    },
  },
};

export const columnCornerRadius = {
  isGroup: true,
  //   padding: [35, 50],
  padding: [35, 50, 80, 50],
  columnStyle: {
    radius: [0, 0, 0, 0],
  },
  xAxis: {
    label: {
      autoRotate: true,
      autoHide: false,
      style: {
        fontSize: 10,
      },
    },
  },
};

export const columnStackedPlot = {
  isStack: true,
  padding: [35, 50],
  label: {
    // 可手动配置 label 数据标签位置
    position: "middle",
    // 'top', 'bottom', 'middle'
    // 可配置附加的布局方法
    layout: [
      // 柱形图数据标签位置自动调整
      {
        type: "interval-adjust-position",
      }, // 数据标签防遮挡
      {
        type: "interval-hide-overlap",
      }, // 数据标签文颜色自动调整
      {
        type: "adjust-color",
      },
    ],
  },
};

export const groupBarPlot = {
  padding: "auto",
  isGroup: true,
  /** 自定义颜色 */
  // color: ['#1383ab', '#c52125'],
  marginRatio: 0,
  label: {
    // 可手动配置 label 数据标签位置
    position: "right",
    style: {
      fill: "#000",
      fontSize: 11,
    },
    // 'left', 'middle', 'right'
    // 可配置附加的布局方法
    layout: [
      // 柱形图数据标签位置自动调整
      {
        type: "interval-adjust-position",
      }, // 数据标签防遮挡
      {
        type: "interval-hide-overlap",
      }, // 数据标签文颜色自动调整
      {
        type: "adjust-color",
      },
    ],
  },
  yAxis: {
    label: {
      autoRotate: false,
      autoHide: false,
      autoEllipsis: true,
      style: {
        fontSize: 11,
      },
      // Enable word wrap for long names
      formatter: (text) => {
        if (text.length > 20) {
          // Wrap text if longer than 20 characters
          return text.substring(0, 20) + "...";
        }
        return text;
      },
    },
  },
};

export const pieLegendAction = {
  appendPadding: 10,
  // angleField: 'value',
  // colorField: 'type',
  radius: 0.8,
  label: {
    type: "outer",
    content: "{name} {percentage}",
  },
  interactions: [
    {
      type: "pie-legend-active",
    },
    {
      type: "element-active",
    },
  ],
};

export const GroupedColumnStackedConfig = {
  isGroup: true,
  padding: [35, 50],
  label: {
    // 可手动配置 label 数据标签位置
    position: "middle",
    // 'top', 'bottom', 'middle'
    // 可配置附加的布局方法
    layout: [
      // 柱形图数据标签位置自动调整
      {
        type: "interval-adjust-position",
      }, // 数据标签防遮挡
      {
        type: "interval-hide-overlap",
      }, // 数据标签文颜色自动调整
      {
        type: "adjust-color",
      },
    ],
  },
};

export const linePlotAction = {
  autoFit: true,
  appendPadding: [0, 0, 50, 0],
  limitInPlot: false,
  point: {
    shapeField: "circle",
    sizeField: 15,
  },
  interaction: {
    tooltip: {
      marker: false,
    },
  },
  style: {
    lineWidth: 2,
  },
  xAxis: {
    label: {
      offset: 10,
      style: {
        fontSize: 11,
      },
    },
  },
};

export const donatPlotAction = {
  angleField: "value",
  colorField: "type",
  innerRadius: 0.7,
  label: {
    text: "value",
    style: {
      fontWeight: "bold",
    },
  },
  legend: {
    color: {
      title: true,
      position: "right",
      rowPadding: 2,
    },
  },
  annotations: [
    {
      type: "text",
      style: {
        text: "AntV\nCharts",
        x: "50%",
        y: "50%",
        textAlign: "center",
        fontSize: 10,
        fontStyle: "bold",
      },
    },
  ],
};
